import React from "react";
import { Button, CircularProgress } from "@material-ui/core";

export default function (props) {
  const { loading, startIcon, ...otherProps } = props;
  // const loadingSvg = (
  //   <SvgIcon>
  //     <img src={loadingBtn} />
  //   </SvgIcon>
  // );
  return (
    <Button startIcon={startIcon} disabled={loading} {...otherProps}>
      {loading && <CircularProgress size={16} />}
      {!loading && props.children}
    </Button>
  );
}
